/***
 *
 *   LANDING
 *   Marketing homepage, shown on the apex domain.
 *   Org subdomains render the account page instead — see views/website/home.js
 *
 **********/

import { Animate } from 'components/lib';
import { LandingHero } from './hero';
import { LandingCapabilities } from './capabilities';
import { LandingTeams } from './teams';
import { LandingIntake } from './intake';
import { LandingIntegrations } from './integrations';
import { LandingCta } from './cta';

export function Landing(props) {
    return (
        <Animate type="pop">
            <LandingHero />
            <LandingCapabilities />
            <LandingTeams />
            <LandingIntake />
            <LandingIntegrations />
            <LandingCta />
        </Animate>
    );
}
